import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {CoverPagePreviewPrint} from '../../widgets/CoverPage/CovePreviewPrint';
import moment from 'moment';
import {TextInput} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import {PERMISSIONS} from '../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../_helpers/UserPermissionSingleton';

export default class VitalSourceSetup extends Component {
    sendVitalsourceInviteEmail = () => {
        this.props.sendVitalsourceInviteEmail(this.props.match.params.collId);
    };

    constructor(props) {
        super(props);
        this.state = {
            studentInviteLinks: [],
            productDeliveryType: ''
        };

        this.updateSubscriptionLength = this.updateSubscriptionLength.bind(this);
    }

    static get propTypes() {
        return {
            getvitalsourceStatusLog: PropTypes.func.isRequired,
            vitalsourceStatuses: PropTypes.object.isRequired,
            sendVitalsourceInviteEmail: PropTypes.func.isRequired,
            subscriptionLength: PropTypes.number,
            setComponent: PropTypes.func,
            guardDirtySetActive: PropTypes.func,
            setSubscriptionLength: PropTypes.func.isRequired,
        };
    }

    componentDidMount() {
        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("VitalSourceSetup");
        }
    }

    componentWillMount() {
        this.props.getvitalsourceStatusLog(this.props.match.params.collId);
    }

    componentWillUnmount() {
        this.props.guardDirtySetActive(false);
    }

    updateSubscriptionLength(event) {
        const re = /^[0-9\b]{1,3}$/;
        if (re.test(event.target.value)) {
            this.props.guardDirtySetActive(true);
            this.props.setSubscriptionLength(event.target.value);
        } else if (event.target.value === '') {
            this.props.guardDirtySetActive(true);
            this.props.setSubscriptionLength(0);
        }
    }

    render() {
        const coverWidth = 220;
        const coverHeight = 250;
        const {orderDetails, activeCollection, vitalsourceStatuses, bookdetails} = this.props;
        const CourseInfo = activeCollection && activeCollection.collectionCourseInformation ? activeCollection.collectionCourseInformation : {};
        const startAndEndDate = (CourseInfo.classStart ? moment(CourseInfo.classStart).format('ll') : '--') + ' - ' + (CourseInfo.classEnd ? moment(CourseInfo.classEnd).format('ll') : '--');
        const {productDeliveryType} = this.state;

        return (<div className='etext_setup_page'>
            <div className='top_info_wrapper'>Review the VitalSource  course information as it will display to Instructors and
                Students. If you need to make changes, return to Book Details and Order Details, then Save changes. Once
                everything looks good, SEND TO VitalSource 
            </div>
            <div className="section_breaker"></div>
            <div className='two_coloumn_wrapper'>
                <div className='left'>
                    <div className="front_cover" style={{width: coverWidth, height: coverHeight}}>
                        {this.props.activeCollection.collectionId ? <CoverPagePreviewPrint
                            renderWidth={coverWidth}
                            pageTrimSize={this.props.activeCollection.pageSize}
                            collectionId={this.props.activeCollection.collectionId}
                            coverPageTextInfo={this.props.coverPageTextInfo}
                            startAndEndDate={startAndEndDate}
                            getCoverPageTextInfo={this.props.getFrontCoverPage}/> :
                            <div className="empty-cover"></div>
                        }
                    </div>
                </div>
                <div className='right'>
                    <h2>Pearson Digital Collection for {activeCollection.title ? activeCollection.title : ''}</h2>
                    <div className='book_info'>
                        <h3>{CourseInfo.courseTitle ? CourseInfo.courseTitle : '--'}</h3>
                        <h4>{bookdetails.field3 ? bookdetails.field3 : ''}</h4>
                        <h4>{startAndEndDate}</h4>
                    </div>
                </div>
            </div>
            <div className='course_info_wrapper'>
                <h2>Course Information</h2>
                <div className='info_block'>
                    <label>Course Name</label>
                    <h4>{CourseInfo.courseTitle ? CourseInfo.courseTitle : '--'}</h4>
                </div>
                <div className='info_block'>
                    <label>Course Number</label>
                    <h4>{CourseInfo.courseNo ? CourseInfo.courseNo : '--'}</h4>
                </div>
                <div className='info_block'>
                    <label>Educator</label>
                    <h4>{orderDetails.contact.instructor ? orderDetails.contact.instructor.firstName : ''} {orderDetails.contact.instructor ? orderDetails.contact.instructor.lastName : ''}</h4>
                </div>
                <div className='info_block two_coloumn'>
                    <div className='left'>
                        <label>Course Dates</label>
                        <h4>{startAndEndDate}</h4>
                    </div>
                    <div className='right'>
                        <div className="access-code-subscription">
                            <div className="subscription-input">
                                <TextInput id="spwAccessCodeId"
                                    labelText="Student subscription length"
                                    fancy={false}
                                    changeHandler={this.updateSubscriptionLength}
                                    inputState={ UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_student_subcription_length) ? "disabled" : "default"}
                                    value={vitalsourceStatuses['subscriptionLength']}
                                />
                                <div className="subscription-days">
                                    <label className="pe-textLabelInput__label">days</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='info_block'>
                    <label>Student Invite Link</label>
                    
                    <div>
                        <div className="invite_link_details">
                            <label className="invite_link_span">Course Dates : {startAndEndDate}</label>                       
                        </div>
                        { !UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_vitalsource_student_invite_link) ? 
                            <h4 style={{position: "relative"}}> <a target="_blank" href={vitalsourceStatuses['STUDENT_LINK']}>{vitalsourceStatuses['STUDENT_LINK']}</a></h4> :
                            <h4 style={{position: "relative"}}>{vitalsourceStatuses['STUDENT_LINK']}</h4> }
                    </div>

                           
                    

                </div>
            </div>
            <div className="section_breaker"></div>
            {!UserPermissionSingleton.hasPermission(PERMISSIONS.hide_vitalsource_log) 
            && <div className="etext_log_wrapper">
                <h2>Vitalsource Log</h2>
                <div className="log_table">
                    <div className="log_row">
                        <p>VitalSource  book creation initiated :</p>
                        <label>{vitalsourceStatuses['VITALSOURCE_BOOK_INITIALIZED']}</label>
                    </div>
                    <div className="log_row">
                        <p>VitalSource  book build status:</p>
                        <label>{vitalsourceStatuses['BOOKBUILD_STATUS']}</label>
                    </div>
                    <div className="log_row">
                        <p>VitalSource  acknowledgement received :</p>
                        <label>{vitalsourceStatuses['VITALSOURCE_ACKNOWLEDGEMENT']}</label>
                    </div>
                    <div className="log_row">
                        <p>VitalSource  Comp Code status :</p>
                        <label>{vitalsourceStatuses['COMP_CODE_GENERATION']}</label>
                    </div>
                    
                    <div className="log_row">
                        <p>Instructor Invite Email Sent:</p>
                        <label>{vitalsourceStatuses['INVITE_EMAIL']}</label>
                    </div>
                </div>

            </div> }
            { !UserPermissionSingleton.hasPermission(PERMISSIONS.hide_vitalsource_invite_instructor) 
            && <div className="email_invite_wrapper">
                {
                    ( vitalsourceStatuses['VITALSOURCE_BOOK_INITIALIZED'].indexOf("SUCCESS") > -1
                    && vitalsourceStatuses['BOOKBUILD_STATUS'].indexOf("approved") > -1
                    && vitalsourceStatuses['VITALSOURCE_ACKNOWLEDGEMENT'].indexOf("SUCCESS") > -1
                    && vitalsourceStatuses['COMP_CODE_GENERATION'].indexOf("SUCCESS") > -1 
                    && vitalsourceStatuses['CALL_BACK_STATUS'].indexOf("Success") > -1) 
                    && vitalsourceStatuses['isBookReadyInStore'] ? 
                        <div>
                            <button onClick={this.sendVitalsourceInviteEmail} className="pe-btn__primary--btn_small">Email Invite
                                to Instructor
                            </button>
                        </div> : <div>
                            <button className="pe-btn__primary--btn_small" disabled>Email Invite to Instructor</button>
                            {(vitalsourceStatuses['INVITE_EMAIL'].indexOf("SUCCESS") > -1) ?
                                <p>Send to VitalSource  process is completed</p> :
                                <p>This button will become active once the VitalSource  is ready to be shared with Instructor</p>}
                        </div>
                }
            </div> }
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/VitalSourceSetup.js